/** CLAÈ – client-side app entry with routes */
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AppProvider } from "@/context/AppContext";
import Catalogue from "@/pages/Catalogue";
import Cart from "@/pages/Cart";
import Booking from "@/pages/Booking";
import Success from "@/pages/Success";
import Cancel from "@/pages/Cancel";
import AdminLogin from "@/pages/AdminLogin";
import Admin from "@/pages/Admin";
import ProtectedAdmin from "@/pages/ProtectedAdmin";
import Consent from "@/pages/Consent";
import SelfCancel from "@/pages/SelfCancel";
import TopupLanding from "@/pages/TopupLanding";
import TopupConfirmed from "@/pages/TopupConfirmed";
import ModelConfirmed from "@/pages/ModelConfirmed";
import ModelDayPublic from "@/pages/ModelDayPublic";
import Aftercare from "@/pages/Aftercare";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import Home from "@/pages/Home";
import About from "@/pages/About";
import FAQs from "@/pages/FAQs";
import Contact from "@/pages/Contact";
import Loyalty from "@/pages/Loyalty";
import CourseSession from "@/pages/CourseSession";
import ConsentReview from "@/pages/ConsentReview";
import BookRefill from "@/pages/BookRefill";
import WhatsAppButton from "@/components/WhatsAppButton";

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <div className="min-h-screen bg-[#FAF9F6] font-sans text-stone-800">
          <Toaster position="top-right" richColors closeButton offset={88} mobileOffset={76} />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/treatments" element={<Catalogue />} />
            <Route path="/about" element={<About />} />
            <Route path="/faqs" element={<FAQs />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/booking" element={<Booking />} />
            <Route path="/booking/success" element={<Success />} />
            <Route path="/booking/cancel" element={<Cancel />} />
            <Route path="/consent/:bid" element={<Consent />} />
            <Route path="/topup/:tid" element={<TopupLanding />} />
            <Route path="/topup/confirmed" element={<TopupConfirmed />} />
            <Route path="/models/confirmed" element={<ModelConfirmed />} />
            <Route path="/model-day/:token" element={<ModelDayPublic />} />
            <Route path="/aftercare/:token" element={<Aftercare />} />
            <Route path="/loyalty/:token" element={<Loyalty />} />
            <Route path="/course/:token" element={<CourseSession />} />
            <Route path="/consent-review/:bid" element={<ConsentReview />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/terms-and-conditions" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/booking/self-cancel/:bid" element={<SelfCancel />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/*" element={<ProtectedAdmin><Admin /></ProtectedAdmin>} />
            <Route path="/book-refill/:pkgid" element={<BookRefill />} />
          </Routes>
          <WhatsAppButton />
        </div>
      </BrowserRouter>
    </AppProvider>
  );
}

export default App;
